if (!bq.marketplace) { bq.marketplace = {}; }

bq.marketplace.wishlist = {
    showList: function (element) {

        var wishlist = jQuery('.wishlist-dropdown');
        var mode = jQuery(element).data('mode');

        wishlist.children('li').removeClass('active');

        if (mode == 'all') {
            var listItems = jQuery(".wishlist-dropdown li.wishlist-list-item");
            var createListButton = jQuery("#wishlist_new_button");

            listItems.each(function (idx, li) {
                var productListLink = jQuery(li).children('a.wishlist-list-name:first-child');
                var wishlistId = productListLink.data('wishlist');
                productListLink.attr('onclick', 'bq.marketplace.wishlist.addCart(' + wishlistId + ')');
            });
            createListButton.attr('onclick', 'bq.marketplace.wishlist.addCart()');
        }

        if (mode == 'single') {
            var listItems = jQuery(".wishlist-dropdown li.wishlist-list-item");
            var createListButton = jQuery("#wishlist_new_button");

            var productId = jQuery(element).data('product-id');
            var quoteItemId = jQuery(element).data('item-id');
            var quoteId = jQuery(element).data('quote-id');
            listItems.each(function (idx, li) {
                var productListLink = jQuery(li).children('a.wishlist-list-name:first-child');
                var productsInList = productListLink.data('products');
                var wishlistId = productListLink.data('wishlist');
                if (productsInList) {
                    if (productsInList.indexOf(productId.toString()) != -1) {
                        jQuery(li).addClass('active');
                    }
                }
                productListLink.attr('onclick', 'bq.marketplace.wishlist.addProductFromCart(' + wishlistId + ',' + quoteItemId + ',' + quoteId + ')');
            });
            createListButton.attr('onclick', 'bq.marketplace.wishlist.addProductFromCart(false,' + quoteItemId + ',' + quoteId + ')');
        }

        jQuery(element).after(wishlist);
        jQuery(element).dropdown();

    },
    updateItem: function(itemId) {
        var form = $('#wishlist-view-form');
        if (form) {
            var itemQty = form.find('[name="qty[' + itemId + ']"]').val(),
                copyWishlistId = form.find('[name="wishlist_copy[' + itemId + ']"]').val(),
                moveWishlistId = form.find('[name="wishlist_move[' + itemId + ']"]').val();

            jQuery('#selected_item_id').val(itemId);
            jQuery('#selected_item_qty').val(itemQty);
            jQuery('#selected_wishlist_copy_id').val(copyWishlistId);
            jQuery('#selected_wishlist_move_id').val(moveWishlistId);

            form.attr('action', bq.urls.wishlist.update);
            form[0].submit();
        }
        return false;
    },

    addAll: function(e) {
        var form = $('#wishlist-view-form');

        if ( ! form.parsley().validate()) {
            return;
        }

        e.disabled = "disabled";
        var url = bq.urls.wishlist.addAll + 'wishlist_id/'+form.data('wishlistid')+'/';

        form.attr('action', url);

        form[0].submit();

    },

    addCart: function (wishlist_id) {
        var params = '';
        if (wishlist_id) {
            params = 'wishlist_id=' + wishlist_id;
        } else {
            var form = $('#wishlist_create');
            if (form.parsley().validate()) {
                params = 'wishlist_name=' + form.find('*[name=wishlist_name]').val();
            }
        }

        if (params.length) {
            setLocation(bq.urls.wishlist.addCart + '?' + params);
        }
    },

    addProductFromCart: function (wishlistId,quoteItemId,quoteId) {
        var form = $('#wishlist_create');

        if (!wishlistId && !form.parsley().validate()) {
            return;
        }

        var url = bq.urls.wishlist.addProductFromCart;

        if (wishlistId) {
            url += '?wishlist_id=' + wishlistId;
        } else {
            var wishlistName = form.find('input[name="wishlist_name"]').val();
            form.find('button').prop('disabled', true);
            url += '?wishlist_name=' + wishlistName;
        }
        url += '&quote_item_id=' + quoteItemId;
        url += '&quote_id=' + quoteId;

        setLocation(url);
    }

};